export default __webpack_public_path__ + "static/media/haridwar.d045794c.jpg";